//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/building'
import LayoutItem from '@/views/building/img_preview/_layout_item'
import audio from '@/views/building/img_preview/mixin/audio'
import CommonFooter from '@/views/building/_components/_common_footer'
import detailSubPage from '@/common/mixins/detailSubPage'
import Preview from './_preview'
import { debounce } from '@/utils'
import { sendUserLog, sendCtmEvtLog } from '@/utils/log'
import EmptyBox from '@/components/views/empty_box'
import VrTip from '../img_preview/_vr_tip'
import vr_tip from '../img_preview/mixin/vr_tip'
import LayoutTip from '@/views/building/_components/_layout_tip'
export default {
    mixins: [
        audio,
        vr_tip
    ],
    components: {
        Preview,
        LayoutItem,
        CommonFooter,
        EmptyBox,
        LayoutTip,
        VrTip
    },
    data () {
        return {
            loading: true,
            building: {
                name: ''
            },
            title: '',
            items: [],
            show_items: [],
            selected_block: 0,
            layout_urls: [],
            layout_loading: false,
            layout_building: {
                activities: []
            },
            show_vr_720: false,
            selected_status: 0,
            favourite: false,
        }
    },
    computed: {
        selected_block_id () {
            if (this.show_items && this.show_items.length) {
                if (this.selected_block > 0) {
                    return this.show_items[this.selected_block - 1].id
                }
                return this.show_items[0].id
            }

        },
        block_center () {
            return this.show_items.length === 1
        },
        block_title () {
            if (this.selected_block === 0 && this.show_items.length) {
                return this.show_items[0].block
            }
            return this.block_options[this.selected_block].block
        },
        hide_layout () {
            return this.layout_urls.length === 0
        },
        status_options () {
            return this.items.reduce((options, item) => {
                const status = item.details['销售状态']
                if (!options.includes(status)) {
                    options.push(status)
                }
                return options
            }, ['全部']).map((status) => ({ status }))
        },
        status_title () {
            if (this.selected_status === 0 && this.show_items.length) {
                return this.show_items[0].status
            }
            return this.status_options[this.selected_status].status
        },
        block_options () {
            return [{
                block: '全部'
            }].concat(this.show_items.map(({ block }, i) => ({
                block
            })))
        },
        show_disclaimer () {
            return this.layout_building.activities && this.layout_building.activities.indexOf('vr_disclaimer') > -1
        }
    },
    created () {
        this.getBuilding()
        this.getData()
        this.initAudio(this.building.name)
    },
    mounted () {
        const { building_id } = this.$route.query
        sendUserLog('fc_planar_graph_view', {
            d_key: building_id,
            d_event: 0
        })
    },
    onShareAppMessage () {
        const { building_id } = this.$route.query
        const { name } = this.building
        const sub_page = encodeURIComponent(`/building/planar_graph?building_id=${building_id || ''}`)
        return this.getShareInfo({
            title: `【${name}】的总平图，更清楚更直观，点击查看~`,
            path: `/building?building_id=${building_id || ''}&sub_page=${sub_page}`
        })
    },
    methods: {
        clickVr720 () {
            sendCtmEvtLog('总平图-航拍点击')
        },
        getBuilding() {
            const { building_id } = this.$route.query
            Service.getBuilding(building_id).then(data => {
                this.favourite = Boolean(data.follow_info && data.follow_info.id)
            })
        },
        async getData () {
            this.loading = true
            this.$wx.showLoading()
            const { building_id } = this.$route.query
            const data = await Service.getBlocks(building_id)
            this.building = data.building
            this.show_vr_720 = data.building.activities && data.building.activities.indexOf('vr_panorama') > -1
            this.title = data.building.name
            this.loading = false
            this.$wx.hideLoading()
            const STATUS_CLASS = {
                '售罄': 'sold_out',
                '待售': 'waiting',
                '即将发售': 'forthcoming',
                '在售': 'surplus'
            }
            this.items = data.items.map(({ id, block, details = {} }) => {
                let detail_keys = Object.keys(details)
                if (detail_keys.length < 4) {
                    detail_keys = ['销售状态', '单元', '层数', '梯户比']
                }
                const status = details['销售状态']
                return {
                    id,
                    block,
                    details,
                    status_class: STATUS_CLASS[status] || '',
                    infos: detail_keys.map((key) => {
                        return `${key}: ${details[key] || '-'}`
                    })
                }
            })
            this.checkShowItems()
            if (this.items && this.items.length) {
                this.selected_block = 0
                this.getLayout()
            } else {
                this.layout_loading = false
            }
        },
        checkShowItems () {
            if (this.selected_status === 0) {
                this.show_items = this.items
            } else {
                console.error('change stataus', this.status_title)
                this.show_items = this.items.filter(({ details }) => {
                    return details['销售状态'] === this.status_title
                })
            }
        },
        async getLayout () {
            this.layout_loading = true
            const { building_id } = this.$route.query
            const data = await Service.getImgs(building_id, 'layout', {
                building_block_id: this.selected_block_id
            })
            this.layout_building = data.building || {}
            const detailParam = encodeURIComponent(`building_id=${building_id}`)
            data.items.forEach((item) => {
                if (item.vr_url) {
                    item.vr_link = `/building/web_vr?building_id=${building_id}&link=${encodeURIComponent(item.vr_url)}&title=${this.building.name}&detailParam=${detailParam}&category_id=${item.id}`
                }
            })
            this.layout_urls = data.items
            this.layout_loading = false
        },
        preview (index) {
            this.$wx.previewImage({
                current: this.layout_urls[index].orginal_url,
                urls: this.layout_urls.map(({ orginal_url }) => orginal_url)
            })
        },
        goVideo (src) {
            const { id, name } = this.building
            this.$router.push({
                path:`/building/video?building_id=${id}&title=${name}&src=${src}`
            })
        },
        onScroll: debounce(function ({ target: { scrollLeft, scrollWidth }}) {
            const percent = scrollLeft / scrollWidth
            const index = Math.round(percent * this.show_items.length) + 1
            console.log(index, this.selected_block)
            if (this.selected_block === 0 && index === 1) {
                return
            }
            if (index != this.selected_block) {
                this.selected_block = index
                this.refreshUrls()
            }
        }, 300),
        refreshUrls () {
            this.layout_urls = []
            setTimeout(this.getLayout, 300)
        },
        changeStatus (e) {
            this.selected_status = Number(e.target.value)
            this.checkShowItems()
            this.refreshUrls()
        },
        changeFavourite () {
            this.favourite = !this.favourite
        }
    }
}
